import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { postSession } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) { navigate("/login", { replace: true }); return; }
      try {
        const user = await postSession(sessionId);
        setUser(user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true, state: { user } });
      } catch (e) {
        setError(true);
        const msg = e?.response?.data?.detail || "Accesso non riuscito. Riprova ad accedere con Google.";
        setTimeout(() => navigate("/login", { replace: true, state: { error: msg } }), 1800);
      }
    };
    run();
  }, [location, navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center">
        <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
        <p className="text-sm text-muted-foreground">
          {error ? "Accesso non riuscito, reindirizzamento..." : "Accesso in corso..."}
        </p>
      </div>
    </div>
  );
}
